import { render, staticRenderFns } from "./InventoryPosting.vue?vue&type=template&id=117301b8&scoped=true"
import script from "./InventoryPosting.vue?vue&type=script&lang=js"
export * from "./InventoryPosting.vue?vue&type=script&lang=js"
import style0 from "./InventoryPosting.vue?vue&type=style&index=0&id=117301b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117301b8",
  null
  
)

export default component.exports